import React from "react";

//Components
import { Button } from "@material-ui/core";
import { Control, Form } from "react-redux-form";
import { withStyles } from "@material-ui/core/styles";

//Deps
import classNames from "classnames";
import { validate } from "./../util";

const styles = theme => ({
  root: {},
  email: {
    pointerEvents: "none",
    color: "#777777"
  },
  form: {
    width: "100%"
  },
  updateProfile: {
    margin: "2em 0"
  }
});

const ProfileForm = props => {
  const {
    classes,
    client,
    cUID,
    darkMode,
    uUID,
    model,

    //Default values from user
    defaultEmail,
    defaultName,
    defaultPhone,
    defaultPosition,
    defaultNotes,

    //Reducer
    handleSubmit,

    //Form Values
    name,
    phone,

    //Form Status
    formIsValid
  } = props;

  const enableDarkMode = classNames({
    dark: darkMode ? true : false
  });

  const groupClass = classNames({
    group: true,
    dark: darkMode ? true : false
  });

  return (
    <Form model={`${model}`} onSubmit={val => handleSubmit(val, cUID || uUID, client)} className={classes.form}>
      <div className={groupClass}>
        <Control.text
          model={`${model}.name`}
          type="text"
          defaultValue={defaultName}
          validators={validate.nameRules(name)}
          className={enableDarkMode}
          required
        />
        <span className="highlight" />
        <span className="bar" />
        <label>name</label>
      </div>
      <div className={groupClass}>
        <Control.text
          className={classes.email}
          tabIndex="-1"
          model={`${model}.email`}
          type="email"
          value={defaultEmail}
          defaultValue={defaultEmail}
        />
        <span className="highlight" />
        <span className="bar" />
        <label>email</label>
      </div>
      <div className={groupClass}>
        <Control.text
          model={`${model}.phone`}
          type="tel"
          defaultValue={defaultPhone}
          parser={validate.phoneParser}
          validators={validate.phoneRules(phone)}
        />
        <span className="highlight" />
        <span className="bar" />
        <label>phone</label>
      </div>
      <div style={{ padding: "2em 0 1em 5px" }}>business details</div>
      <div>
        <div className={groupClass}>
          <Control.text model={`${model}.position`} type="text" defaultValue={defaultPosition} />
          <span className="highlight" />
          <span className="bar" />
          <label>position</label>
        </div>
        <div className={groupClass}>
          <Control.text model={`${model}.notes`} type="text" defaultValue={defaultNotes} />
          <span className="highlight" />
          <span className="bar" />
          <label>notes</label>
        </div>
      </div>
      <Button className={classes.updateProfile} type="submit" variant="raised" color="primary" fullWidth={true} disabled={!formIsValid}>
        update profile
      </Button>
    </Form>
  );
};

export default withStyles(styles)(ProfileForm);



// WEBPACK FOOTER //
// ./src/components/ProfileForm.js